import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Box } from '@gemini/core';
import { SelectCardGroup } from '@gemini/ui';
import { Controller, useFormContext } from 'react-hook-form';
import { useCommonPopinImgUserType } from '@/contexts/brandConfiguration/hooks';
import { useTranslation } from '@/hooks/useTranslations';
export const UserContent = () => {
    const { t } = useTranslation();
    const img = useCommonPopinImgUserType();
    const { control, formState: { errors }, } = useFormContext();
    const itemsUserType = [
        {
            image: img.private,
            label: t(`common.popin.users.item1`),
            value: 'private',
        },
        {
            image: img.pro,
            label: t(`common.popin.users.item2`),
            value: 'pro',
        },
    ];
    return (_jsx(Box, { marginBottom: "spacing.32", children: _jsx(Controller, { name: "user", control: control, render: ({ field }) => {
                var _a;
                return (_jsx(SelectCardGroup, { hasNecessityIndicator: false, type: "radio", items: itemsUserType, label: "", error: (_a = errors.user) === null || _a === void 0 ? void 0 : _a.message, "aria-label": "dispatch-modal", ...field }));
            } }) }));
};
